import { render, staticRenderFns } from "./PageHeadContainerNew.vue?vue&type=template&id=8f40ce64&scoped=true"
import script from "./PageHeadContainerNew.vue?vue&type=script&lang=ts"
export * from "./PageHeadContainerNew.vue?vue&type=script&lang=ts"
import style0 from "./PageHeadContainerNew.vue?vue&type=style&index=0&id=8f40ce64&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f40ce64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f40ce64')) {
      api.createRecord('8f40ce64', component.options)
    } else {
      api.reload('8f40ce64', component.options)
    }
    module.hot.accept("./PageHeadContainerNew.vue?vue&type=template&id=8f40ce64&scoped=true", function () {
      api.rerender('8f40ce64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/PageHeadContainerNew.vue"
export default component.exports